'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('./tslib.es6-f8b34207.js');
var eventEmitter = require('./eventEmitter.js');
var lodash = require('lodash');
var device = require('./device.js');
require('ua-parser-js');

//todo: backend should add Access-Control-Expose-Headers: Content-Length to all api responses!
var AVERAGE_HEADERS_SIZE = 300;
var GZIP_AVERAGE_COMPRESSION_LEVEL = 0.8; // 1 - decodedBodySize/encodedBodySize
var NetworkProfiling = /** @class */ (function (_super) {
    tslib_es6.__extends(NetworkProfiling, _super);
    function NetworkProfiling() {
        var _this = _super.call(this) || this;
        _this.netInfo = {};
        // @ts-ignore
        _this.browserNetInfo = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
        _this.init();
        return _this;
    }
    NetworkProfiling.isInstantiate = function () {
        return !!NetworkProfiling._instance;
    };
    NetworkProfiling.instance = function () {
        if (!NetworkProfiling._instance) {
            NetworkProfiling._instance = new NetworkProfiling();
        }
        return NetworkProfiling._instance;
    };
    NetworkProfiling.prototype.init = function () {
        if (this.browserNetInfo) {
            this.netInfo.type = this.browserNetInfo.type;
            this.netInfo.effectiveType = this.browserNetInfo.effectiveType;
            this.netInfo.downlinkMax = this.browserNetInfo.downlinkMax;
            this.netInfo.downlink = this.browserNetInfo.downlink;
            this.netInfo.rtt = this.browserNetInfo.rtt;
            this.addOrigListener();
        }
        else {
            this.netInfo.type = 'unknown';
            // this.generateInitialInfo();
        }
        console.log('[NetworkProfiling][init]', this.browserNetInfo, this.netInfo);
    };
    // private generateInitialInfo() {
    //   let resources = performance.getEntriesByType('resource');
    //   resources.forEach((value, index, array) => {
    //     this.handleResponse();
    //   });
    // }
    NetworkProfiling.prototype.addOrigListener = function () {
        var _this = this;
        this.browserNetInfo.addEventListener('change', function () {
            _this.netInfo.type = _this.browserNetInfo.type || _this.netInfo.type;
            _this.netInfo.effectiveType = _this.browserNetInfo.effectiveType;
            _this.netInfo.downlinkMax = _this.browserNetInfo.downlinkMax || _this.browserNetInfo.downlink || null;
            _this.netInfo.downlink = _this.browserNetInfo.downlink;
            _this.netInfo.rtt = _this.browserNetInfo.rtt;
            _this.emit('change');
        });
    };
    NetworkProfiling.prototype.handleType = function () {
        var type;
        var effectiveType;
        if (['mobile', 'wearable'].includes(device.device.getDeviceType())) {
            type = 'cellular';
        }
        else if (['tablet'].includes(device.device.getDeviceType())) {
            type = 'wifi';
        }
        else {
            type = 'ethernet';
        }
        if (this.netInfo.downlink >= 0.01 && this.netInfo.downlink < 0.15) {
            effectiveType = 'slow-2g';
        }
        else if (this.netInfo.downlink >= 0.15 && this.netInfo.downlink < 2) {
            effectiveType = '2g';
        }
        else if (this.netInfo.downlink >= 2 && this.netInfo.downlink < 3.6) {
            effectiveType = '3g';
        }
        else if (this.netInfo.downlink >= 3.6) {
            effectiveType = '4g';
            /** todo: possible wifi*/
        }
        return { type: type, effectiveType: effectiveType };
    };
    /**
     * @return {number} Mbps the effective bandwidth estimate in megabits per second, rounded to the nearest multiple of 25 kilobits per seconds.
     * */
    NetworkProfiling.prototype.handleDownLink = function (res, resourceTiming) {
        return tslib_es6.__awaiter(this, void 0, void 0, function () {
            var transferSize, responseTime, bandwidth;
            return tslib_es6.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.calcTransferSize(res, resourceTiming)];
                    case 1:
                        transferSize = _a.sent();
                        return [4 /*yield*/, this.calcResponseTime(resourceTiming)];
                    case 2:
                        responseTime = _a.sent();
                        bandwidth = +((transferSize * 8) / responseTime / 1000).toFixed(2);
                        // console.log('[NetworkProfiling][handleDownLink]', {
                        //   transferSize,
                        //   responseTime,
                        // }, bandwidth);
                        return [2 /*return*/, bandwidth > 0 ? bandwidth : 0.1];
                }
            });
        });
    };
    NetworkProfiling.prototype.getInfo = function () {
        return this.netInfo;
    };
    /**
     * @return {number} transferred bytes
     * */
    NetworkProfiling.prototype.calcTransferSize = function (res, resourceTiming) {
        return tslib_es6.__awaiter(this, void 0, void 0, function () {
            var blob;
            return tslib_es6.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(resourceTiming === null || resourceTiming === void 0 ? void 0 : resourceTiming.transferSize)) return [3 /*break*/, 1];
                        return [2 /*return*/, resourceTiming === null || resourceTiming === void 0 ? void 0 : resourceTiming.transferSize];
                    case 1:
                        if (!(resourceTiming === null || resourceTiming === void 0 ? void 0 : resourceTiming.encodedBodySize)) return [3 /*break*/, 2];
                        return [2 /*return*/, (resourceTiming === null || resourceTiming === void 0 ? void 0 : resourceTiming.encodedBodySize) + AVERAGE_HEADERS_SIZE];
                    case 2:
                        if (!(resourceTiming === null || resourceTiming === void 0 ? void 0 : resourceTiming.decodedBodySize)) return [3 /*break*/, 3];
                        return [2 /*return*/, ((resourceTiming === null || resourceTiming === void 0 ? void 0 : resourceTiming.decodedBodySize) / GZIP_AVERAGE_COMPRESSION_LEVEL) + AVERAGE_HEADERS_SIZE];
                    case 3:
                        if (!(res && res.headers.get('Content-Length'))) return [3 /*break*/, 4];
                        return [2 /*return*/, lodash.parseInt(res.headers.get('Content-Length')) + AVERAGE_HEADERS_SIZE];
                    case 4:
                        if (!res) return [3 /*break*/, 6];
                        return [4 /*yield*/, res.blob()];
                    case 5:
                        blob = _a.sent();
                        return [2 /*return*/, (blob.size / GZIP_AVERAGE_COMPRESSION_LEVEL) + AVERAGE_HEADERS_SIZE];
                    case 6: //todo:
                    return [2 /*return*/, null];
                }
            });
        });
    };
    /**
     * @return {number} transferred time (milliseconds)
     * */
    NetworkProfiling.prototype.calcResponseTime = function (resourceTiming) {
        return tslib_es6.__awaiter(this, void 0, void 0, function () {
            return tslib_es6.__generator(this, function (_a) {
                if ((resourceTiming === null || resourceTiming === void 0 ? void 0 : resourceTiming.responseEnd) && (resourceTiming === null || resourceTiming === void 0 ? void 0 : resourceTiming.responseStart)) {
                    return [2 /*return*/, Math.round(resourceTiming.responseEnd - resourceTiming.responseStart) || 1];
                }
                return [2 /*return*/, 1];
            });
        });
    };
    NetworkProfiling.prototype.handleResponse = function (res, resourceTiming) {
        var _a, _b, _c, _d, _e;
        if (res === void 0) { res = null; }
        if (resourceTiming === void 0) { resourceTiming = null; }
        return tslib_es6.__awaiter(this, void 0, void 0, function () {
            var resourceTimings, changed, _f, _g, type, effectiveType;
            return tslib_es6.__generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        if (!resourceTiming) {
                            resourceTimings = window.performance.getEntriesByName(res.url);
                            resourceTiming = resourceTimings.length ? resourceTimings[resourceTimings.length - 1] : null;
                        }
                        changed = false;
                        if (!!((_a = this.browserNetInfo) === null || _a === void 0 ? void 0 : _a.downlink)) return [3 /*break*/, 2];
                        _f = this.netInfo;
                        return [4 /*yield*/, this.handleDownLink(res, resourceTiming)];
                    case 1:
                        _f.downlink = _h.sent();
                        changed = true;
                        _h.label = 2;
                    case 2:
                        this.netInfo.downlinkMax = !this.netInfo.downlinkMax || this.netInfo.downlink > this.netInfo.downlinkMax ? this.netInfo.downlink : this.netInfo.downlinkMax;
                        // if (!this.browserNetInfo?.rtt) {
                        //   this.netInfo.rtt = resourceTiming.responseEnd - resourceTiming.responseStart;
                        // }
                        if (!((_b = this.browserNetInfo) === null || _b === void 0 ? void 0 : _b.type) || !((_c = this.browserNetInfo) === null || _c === void 0 ? void 0 : _c.effectiveType)) {
                            _g = this.handleType(), type = _g.type, effectiveType = _g.effectiveType;
                            if (!((_d = this.browserNetInfo) === null || _d === void 0 ? void 0 : _d.type)) {
                                this.netInfo.type = type;
                                changed = true;
                            }
                            if (!((_e = this.browserNetInfo) === null || _e === void 0 ? void 0 : _e.effectiveType)) {
                                if (this.netInfo.effectiveType && this.netInfo.effectiveType !== effectiveType) {
                                    this.netInfo.downlinkMax = this.netInfo.downlink;
                                }
                                this.netInfo.effectiveType = effectiveType;
                                changed = true;
                            }
                        }
                        if (changed) {
                            this.emit('change');
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    NetworkProfiling._instance = null;
    return NetworkProfiling;
}(eventEmitter.EventEmitter));

exports.NetworkProfiling = NetworkProfiling;
